// Mirrors the permission slugs seeded by RolesAndPermissionsSeeder on the backend.
export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard.view',
  APPLICATIONS_VIEW: 'statements.view',
  APPLICATIONS_UPLOAD: 'statements.upload',
  APPLICATIONS_PROCESS: 'statements.process',
  TRANSACTIONS_VIEW: 'transactions.view',
  CUSTOMERS_VIEW: 'customers.view',
  CUSTOMERS_MANAGE: 'customers.manage',
  REPORTS_VIEW: 'reports.view',
  REPORTS_MANAGE: 'reports.generate',
  CREDIT_SCORES_VIEW: 'credit-scores.view',
  CREDIT_SCORES_MANAGE: 'credit-scores.manage',
  USERS_MANAGE: 'users.manage',
  ROLES_MANAGE: 'roles.manage',
  AUDIT_VIEW: 'audit-logs.view',
  SETTINGS_MANAGE: 'settings.manage',
} as const

export type PermissionSlug = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]

export const PERMISSION_MODULES = [
  { name: 'Dashboard', permissions: [PERMISSIONS.DASHBOARD_VIEW] },
  { name: 'Applications', permissions: [PERMISSIONS.APPLICATIONS_VIEW, PERMISSIONS.APPLICATIONS_UPLOAD, PERMISSIONS.APPLICATIONS_PROCESS, PERMISSIONS.TRANSACTIONS_VIEW] },
  { name: 'Customers', permissions: [PERMISSIONS.CUSTOMERS_VIEW, PERMISSIONS.CUSTOMERS_MANAGE] },
  { name: 'Reports', permissions: [PERMISSIONS.REPORTS_VIEW, PERMISSIONS.REPORTS_MANAGE, PERMISSIONS.CREDIT_SCORES_VIEW, PERMISSIONS.CREDIT_SCORES_MANAGE] },
  { name: 'Administration', permissions: [PERMISSIONS.USERS_MANAGE, PERMISSIONS.ROLES_MANAGE, PERMISSIONS.AUDIT_VIEW] },
  { name: 'Settings', permissions: [PERMISSIONS.SETTINGS_MANAGE] },
]

export const allPermissions: PermissionSlug[] = PERMISSION_MODULES.flatMap((m) => m.permissions)
